import React from 'react';
import { TooltipContent } from './TooltipContent/TooltipContent.js';
import { Popover } from '../Popover/Popover.js';
import '../Popover/PopoverHelper/PopoverHelper.js';
import '@beeline/design-tokens/js/iconfont/icons';
import { classNames } from '../../helpers/classnames.js';
import '../Icon/Icon.js';
import '../Typography/Typography.js';
import '../Button/Button.js';
import '../Button/ProgressButton/ProgressButton.js';

var Tooltip = function (_a) {
    var title = _a.title, disableHover = _a.disableHover, className = _a.className, popoverRootClassName = _a.popoverRootClassName, children = _a.children, _b = _a.dataTestId, dataTestId = _b === void 0 ? 'Tooltip' : _b;
    return (React.createElement(Popover, { popoverClassName: classNames(popoverRootClassName), disableHover: disableHover, content: React.createElement(TooltipContent, { title: title, className: className }), dataTestId: dataTestId }, children));
};

export { Tooltip };
